import type { GroupResponsibleState } from '@/scopes/account/group-responsible/domain/types'

export function isBookingTabActive(state: GroupResponsibleState) {
  return state.activeTab === 'booking'
}

export function isParticipantsTabActive(state: GroupResponsibleState) {
  return state.activeTab === 'participants'
}

export function isRoomsTabActive(state: GroupResponsibleState) {
  return state.activeTab === 'rooms'
}

export function isBusTabActive(state: GroupResponsibleState) {
  return state.activeTab === 'bus'
}
